import { Component, effect, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TruncateDirective } from 'shared';
import { HlmButton } from '@spartan-ng/helm/button';
import { AvatarComponent } from '../avatar/avatar.component';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import type {
  SidebarListFooterAction,
  SidebarListItem,
  SidebarListVariant,
} from './sidebar-list.interfaces';
import { SidebarListStore } from './sidebar-list.store';

@Component({
  selector: 'ocp-sidebar-list',
  imports: [
    TranslatePipe,
    TruncateDirective,
    HlmButton,
    AvatarComponent,
    ThemedIconComponent,
    RouterLink,
  ],
  templateUrl: './sidebar-list.component.html',
  styleUrl: './sidebar-list.component.scss',
  providers: [SidebarListStore],
})
export class SidebarListComponent {
  private readonly store = inject(SidebarListStore);

  readonly items = input<SidebarListItem[]>([]);
  readonly title = input<string | undefined>(undefined);
  readonly createLabel = input<string | undefined>(undefined);
  readonly footerActions = input<SidebarListFooterAction[]>([]);
  readonly variant = input<SidebarListVariant>('avatar');
  readonly showCreateInHeader = input(false);
  readonly showCreate = input(false);
  readonly showSelectionIndicator = input(true);

  readonly itemClicked = output<SidebarListItem>();
  readonly createClicked = output<void>();
  readonly footerActionClicked = output<SidebarListFooterAction>();

  readonly hasSelectedItem = this.store.hasSelectedItem;
  readonly resolvedVariant = this.store.resolvedVariant;
  readonly showHeader = this.store.showHeader;
  readonly headerTitle = this.store.headerTitle;
  readonly headerCreateLabel = this.store.headerCreateLabel;
  readonly viewItems = this.store.viewItems;

  constructor() {
    effect(() => this.store.items.set(this.items()));
    effect(() => this.store.title.set(this.title()));
    effect(() => this.store.createLabel.set(this.createLabel()));
    effect(() => this.store.footerActions.set(this.footerActions()));
    effect(() => this.store.variant.set(this.variant()));
    effect(() => this.store.showCreateInHeader.set(this.showCreateInHeader()));
    effect(() => this.store.showCreate.set(this.showCreate()));
    effect(() => this.store.showSelectionIndicator.set(this.showSelectionIndicator()));
  }

  protected onItemClick(item: SidebarListItem): void {
    this.itemClicked.emit(item);
  }

  protected onCreateClick(): void {
    this.createClicked.emit();
  }

  protected onResolvedFooterActionClick(action: SidebarListFooterAction): void {
    this.footerActionClicked.emit(action);
    action.command?.();
  }
}
